import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var ArrowCRightIcon16Light = forwardRefAndName('ArrowCRightIcon16Light', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M5.644 3.149a.5.5 0 0 1 .707-.005l3.843 3.793a1.5 1.5 0 0 1 .006 2.128l-3.788 3.789a.5.5 0 0 1-.707-.708l3.788-3.788a.5.5 0 0 0-.002-.71L5.649 3.857a.5.5 0 0 1-.005-.707Z"
    }))
  );
});